/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListString } from '../../models/api-response-list-string';

export interface GetUsersForTicket$Params {
  requestId: string;
  canal: string;
}

export function getUsersForTicket(http: HttpClient, rootUrl: string, params: GetUsersForTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListString>> {
  const rb = new RequestBuilder(rootUrl, getUsersForTicket.PATH, 'get');
  if (params) {
    rb.query('requestId', params.requestId, {});
    rb.query('canal', params.canal, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListString>;
    })
  );
}

getUsersForTicket.PATH = '/v1/api/ui/manage-ticket/getUsersForTicket';
